import type { InputBarTarget } from "@/stores/input-bar-target-store";

export type InputBarTargetKind = "chat" | "subagent";

/** A native sub-agent conversation addressed directly by the input bar. */
export type SubagentInputBarTarget = InputBarTarget & {
  kind: "subagent";
  taskId: string;
  projectId: string;
};

/** The one kind check for every consumer (send, voice, worker controls, ring,
 *  model pill, receipt adoption). Targets mirrored or persisted before `kind`
 *  existed, and a "subagent" target missing its task or project, are chats. */
export function isSubagentTarget(
  target: InputBarTarget | null | undefined,
): target is SubagentInputBarTarget {
  return target?.kind === "subagent" && !!target.taskId && !!target.projectId;
}

/** Whether input sent to this target reaches it: user input always goes to
 *  Denker, so another agent's chat is not addressed (the prompt goes to
 *  Denker's current chat instead). A target without an agent key is
 *  Denker's. Dispatch, prewarm and the draft topic check all ask this. */
export function isDenkerInputTarget(
  target: InputBarTarget | null | undefined,
): target is InputBarTarget {
  return !!target && (target.agentKey ?? "denker").toLowerCase() === "denker";
}
